import { ContentItemProperties } from '@/data/types/Slot';

const contentItems: ContentItemProperties[] = [
    { emsName: 'IT-Revoke-Order-Form-Header-eSpot' },
    { emsName: 'IT-Revoke-Order-Form-Footer-eSpot' },
    { emsName: 'IT-Returns-Product-Display-Message-eSpot' },
    { emsName: 'Revoke_Order_Complete_Next_Step_1_espot' },
    { emsName: 'Revoke_Order_Complete_Next_Step_2_espot' },
    { emsName: 'Revoke_order_error_msg_espot' },
    { emsName: 'Revoke_order_error_page_text_espot' }
];
export default contentItems;
